import React from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section className="relative z-10 px-6 py-20 md:py-32 text-center" data-id="element-19">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-20">
        <h2 className="text-4xl md:text-5xl font-bold text-white font-heading mb-6" data-id="element-21">
          Empieza hoy el viaje hacia su mejor versión.
        </h2>

        <p className="text-xl md:text-2xl text-mutedPurple font-body mb-12 max-w-2xl mx-auto" data-id="element-22">
          Por menos de lo que cuesta un café y un pastel, estarás invirtiendo en
          la seguridad emocional de tu hijo/a para toda la vida.
        </p>

        <motion.a href="https://growincalm.com/cart/46562362097820:1" target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="relative group inline-flex items-center justify-center px-8 py-5 text-lg md:text-xl font-bold text-navy bg-gold rounded-full animate-glow-pulse font-heading overflow-hidden no-underline" data-id="element-23">
          <span className="relative z-10" data-id="element-24">DESCÁRGALO AHORA POR SOLO $7.99</span>
          <div className="absolute inset-0 h-full w-full bg-white/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out" data-id="element-25"></div>
        </motion.a>

        <div className="mt-6 flex items-center justify-center space-x-2 text-sm text-mutedPurple font-body" data-id="element-26">
          <span data-id="element-27">🔒 Pago 100% Seguro</span>
          <span data-id="element-28">•</span>
          <span data-id="element-29">⭐ Acceso Inmediato</span>
        </div>
      </motion.div>
    </section>;
}